export const CAR_OPTIONS = {
  USED: "Gebrauchtwagen",
  NEW: "Neuwagen",
};
export type CarOptionsKey = keyof typeof CAR_OPTIONS;